import React from 'react';

import { RunIdentificationPair } from './entity-model';

export type LineageEntityType = 'RUN' | 'EXPERIMENT';

export type LineageEntityTypeContext = {
  isSelectedAsExperiment: (
    projectIdentifier: string,
    pairOrRunId: RunIdentificationPair | string,
  ) => boolean;
  isSelectedAsRun: (projectIdentifier: string, runId: string) => boolean;
  getLineageEntityType(
    projectIdentifier: string,
    pairOrRunId: RunIdentificationPair | string,
  ): LineageEntityType;
  getEntityIdentificationKeyInContextOfLineage(
    projectIdentifier: string,
    pair: RunIdentificationPair,
  ): string;
  /**
   * Active mode of hosts with a global runs/experiments toggle (project runs compare and table):
   * `false` in runs mode, `true` in experiments mode. Undefined for hosts that classify each entity
   * by its own selection (reports, run and experiment pages).
   */
  experimentsOnlyMode?: boolean;
};

export const LineageEntityTypeContext = React.createContext<LineageEntityTypeContext>({
  isSelectedAsExperiment: () => {
    throw new Error('LineageEntityTypeContext is not provided');
  },
  isSelectedAsRun: () => {
    throw new Error('LineageEntityTypeContext is not provided');
  },
  getLineageEntityType: () => {
    throw new Error('LineageEntityTypeContext is not provided');
  },
  getEntityIdentificationKeyInContextOfLineage: () => {
    throw new Error('LineageEntityTypeContext is not provided');
  },
});
